/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_My_TrainersInputs */

const en_us2_coaching_my_trainers = /** @type {(inputs: Coaching_My_TrainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My trainer`)
};

const pt_br2_coaching_my_trainers = /** @type {(inputs: Coaching_My_TrainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu personal`)
};

const pt_pt2_coaching_my_trainers = /** @type {(inputs: Coaching_My_TrainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu personal`)
};

/** @type {(inputs: Coaching_My_TrainersInputs) => LocalizedString} */
const es_419_coaching_my_trainers = en_us2_coaching_my_trainers;

/** @type {(inputs: Coaching_My_TrainersInputs) => LocalizedString} */
const fr_fr2_coaching_my_trainers = en_us2_coaching_my_trainers;

/** @type {(inputs: Coaching_My_TrainersInputs) => LocalizedString} */
const de_de2_coaching_my_trainers = en_us2_coaching_my_trainers;

/** @type {(inputs: Coaching_My_TrainersInputs) => LocalizedString} */
const it_it2_coaching_my_trainers = en_us2_coaching_my_trainers;

/**
* | output |
* | --- |
* | "My trainer" |
*
* @param {Coaching_My_TrainersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_my_trainers = /** @type {((inputs?: Coaching_My_TrainersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_My_TrainersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_my_trainers(inputs)
	if (locale === "es-419") return es_419_coaching_my_trainers(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_my_trainers(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_my_trainers(inputs)
	if (locale === "de-DE") return de_de2_coaching_my_trainers(inputs)
	if (locale === "it-IT") return it_it2_coaching_my_trainers(inputs)
	return en_us2_coaching_my_trainers(inputs)
});
export { coaching_my_trainers as "coaching.my_trainers" }